import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './OrderFeeDetails.module.scss'
import { BigOrderItem, Order } from 'src/core/models'
import { 
  getOrderItemVatAmount, 
  getOrderItemFeeAmount, 
  getOrderItemTransactionAmount,
  getOrderItemTransactionFeeAmount,
  getOrderItemVatAmountForCustomerInvoice 
} from 'src/core/helpers'
import { CustomTitle, CustomCol } from 'src/components'

interface OrderFeeDetailsProps {
  order: Order
  orderItem: BigOrderItem
}

const OrderFeeDetails: React.FC<OrderFeeDetailsProps> = ({ order, orderItem }) => {
  const { t } = useTranslation()
  const code = (orderItem.customerInvoice ? 
    orderItem.order_currency : 
    orderItem.project_currency_token) // Este en realidad es el del User

  const labels = orderItem.customerInvoice ? [
    {
      label: t('Transactions.Fee'),
      strongLabel: getOrderItemFeeAmount(order, orderItem, code),
      show: order.status === 'paid' && (+orderItem.customerInvoiceFeeAmount > 0)
    },
    {
      label: t('Transactions.TransactionFee'),
      strongLabel: getOrderItemTransactionFeeAmount(order, orderItem, code),
      show: orderItem.customerInvoiceTransactionFeeAmount
    },
    {
      label: t('Transactions.VAT'),
      strongLabel: getOrderItemVatAmountForCustomerInvoice(order, orderItem, code),
      show: orderItem.customerInvoiceVatAmount
    },
  ] : [
    {
      label: t('Transactions.Developer'),
      strongLabel: getOrderItemTransactionAmount(order, orderItem, code),
      show: true,
    },
    {
      label: t('Transactions.PDeveloperVat'),
      strongLabel: getOrderItemVatAmount(order, orderItem, 'p2p', code),
      show: order.status === 'paid' && (+orderItem.invoiceP2pTaxAmount > 0 || +orderItem.breakdownP2pTaxAmount > 0)
    },
    {
      label: t('Transactions.TransactionFee'),
      strongLabel: getOrderItemFeeAmount(order, orderItem, code),
      show: orderItem.invoiceFeeBaseAmount || orderItem.breakdownFeeBaseAmount
    },
    {
      label: t('Transactions.TransactionFeeVat'),
      strongLabel: getOrderItemVatAmount(order, orderItem, 'fee', code),
      show: orderItem.invoiceFeeTaxAmount || orderItem.breakdownFeeTaxAmount
    },
  ]

  return <>
    <CustomTitle label={orderItem.customerInvoice ? t('Transactions.FeesAndTaxes') : t('Transactions.FeeDetails')} type={null} />
    {labels.map((x, idx) => {
      if (!x.show) return
      return (
        <Row key={idx}>
          <CustomCol xs={12}>
            <CustomTitle label={x.label} />
          </CustomCol>
          <CustomCol xs={12} className={styles.texts}>
            <CustomTitle label={x.strongLabel} type={null}/>
          </CustomCol>
        </Row>
      )
    })}
  </>
}

export default OrderFeeDetails
